// integra-icp.service.ts
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiGateway } from "../../../api-gateway";
import { Performer } from "../../../models/backend-definitions.module";

export interface IcpClearanceTO {
    clearanceId?: string;
    productName: string;
    providerName: string;
    clearanceType: string;
    clearanceEndpoint: string;
}

export interface IcpAuthenticationResponseTO {
    requestId: string;
    channelName: string;
    expireTimestamp: string;
    clearances: IcpClearanceTO[];
}

@Injectable({ providedIn: "root" })
export class IntegraIcpService {
    constructor(
        private http: HttpClient,
        public gw: ApiGateway,
    ) {}

    startAuthentication(performer_id: number): Observable<any> {
        const userStr = localStorage.getItem("user");
        let user: any = null;

        if (userStr) {
            user = JSON.parse(userStr);
        }

        return this.gw.post(
            "valid/icp/authentications/" + user.id + "/" + performer_id,
            {},
        );
    }

    updateParameterCredential(
        credential_id: string,
        performer_id: number,
        sectret_data: string
    ): Observable<any> {
        return this.gw.post(
            "valid/icp/credential/" + credential_id + "/" + performer_id + "/" + sectret_data,
            {},
        );
    }

    getCredentialDetails(performerId: number): Observable<any> {
        return this.gw.get(`valid/icp/credential/details/${performerId}`);
    }



    signedPdf(document: any, performer: Performer): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(
                    `valid/sign/${document.id}/${
                        performer.id
                    }?medico=${performer.id}&paciente=${
                        document.patient.id
                    }&sistema=${1}`
                )
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error(error) {
                        console.error(error);
                    },
                });
        });
    }

    signedRequestPdf(request: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    `valid/request/sign`, request
                )
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error(error) {
                        console.error(error);
                    },
                });
        });
    }
}
